import React, { useEffect, useContext, useState } from 'react';
import styles from './NStartScreen.module.css';
import { useNavigate } from "react-router-dom";
import TelegramHeader from '../../Utils/TelegramHeader';
import { useVKAuth } from '../VkAuth/useVkLogic.js'; // Импортируем хук
import { AuthContext } from "../../../context/AuthContext.jsx";
import localeRu from '../../../locales/ru/auth/nstartscreen.json';
import localeEn from '../../../locales/en/auth/nstartscreen.json';
import useStateBackend from "../../../hooks/useStateBackend";
import mainLogo from "../../../img/mainLogo.svg";
import { toast } from 'react-toastify';
import config from '../../../settings/config';
import Loading from '../../Utils/Loading';

const NStartScreen = () => {
    const navigate = useNavigate();
    // postEvent('web_app_add_to_home_screen', { color_key: 'bg_color' });
    const { setAuthData } = useContext(AuthContext);
    const [isCanChangeKeys, setCanChangeKeys] = useState(false);
    const languagesSlavic = ['ru', 'by', 'ua'];
    localStorage.setItem('pinAttempts', 3);
    const [isOnline, setIsOnline] = useState(null); // null - проверка не завершена, true/false - результат
    const [loading, setLoading] = useState(false);

    // Используем улучшенный хук с проверкой состояния
    const { isBackendUp, isChecking } = useStateBackend();
    useVKAuth(setAuthData, isCanChangeKeys); // Используем хук

    useEffect(() => {
        const checkBackendStatus = async () => {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 5000);

            try {
                const response = await fetch(`${config.app.host}/api/v1/ping`, {
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                    signal: controller.signal
                });

                clearTimeout(timeoutId);

                if (response.ok) {
                    setIsOnline(true);
                    localStorage.setItem('backendState', 'true');
                } else {
                    setIsOnline(false);
                    localStorage.setItem('backendState', 'false');
                    navigate('/waiting');
                    return; // Прерываем дальнейшую логику
                }
            } catch (error) {
                clearTimeout(timeoutId);
                setIsOnline(false);
                localStorage.setItem('backendState', 'false');
                navigate('/waiting');
                return; // Прерываем дальнейшую логику
            }
        };

        checkBackendStatus();
    }, [navigate]);


    useEffect(() => {
        if (isOnline === false) {
            return;
        }

        // Если проверка еще не завершена, ждем
        if (isOnline === null) {
            return;
        }
        const tg = window.Telegram?.WebApp;
        if (!tg?.initDataUnsafe?.start_param) return;

        const startParam = tg.initDataUnsafe.start_param;

        if (!startParam || startParam === "null") return;

        // проверяем, совпадает ли с последним
        const lastParam = localStorage.getItem("last_start_param");
        if (lastParam === startParam) {
            return;
        }

        // сохраняем как последний обработанный
        localStorage.setItem("last_start_param", startParam);

        getAuth(startParam);
    }, [isOnline]);

    useEffect(() => {
        if (isOnline === false || isOnline === null) return;
        const tg = window.Telegram?.WebApp;
        if (tg && tg.initDataUnsafe && tg.initDataUnsafe.user) {
            return;
        } 
        const hash = window.location.hash;
        const queryString = hash.split("?")[1];
        const params = new URLSearchParams(queryString);
        const webToken = params.get("web_token");

        if (!webToken) return;
        handleWebToken(webToken);

    }, [isOnline]);

    useEffect(() => {
        if (isOnline === false) {
            return;
        }

        // Если проверка еще не завершена, ждем
        if (isOnline === null) {
            return;
        }
        if (!localStorage.getItem('language')) {
            const userLanguage = navigator.language || navigator.languages[0];
            let subLanguage = userLanguage?.substring(0, 2)
            if (languagesSlavic.includes(subLanguage)) {
                localStorage.setItem('language', 'ru');
            } else {
                localStorage.setItem('language', 'en');
            }
            localStorage.setItem('language', subLanguage);
        }

        if (localStorage.getItem('vkloginprocess') && !localStorage.getItem("pin")) {
            if (localStorage.getItem('isPin')) {
                if (localStorage.getItem('isPin') === "false") {
                    navigate("/checkProfile");
                } else {
                    navigate('/pinoffer');
                }
            } else {
                navigate("/checkProfile");
            }

        } else if (localStorage.getItem('vkloginprocess') && localStorage.getItem("pin")) {
            if (localStorage.getItem('isPin')) {
                if (localStorage.getItem('isPin') === "false") {
                    navigate("/checkProfile");
                } else {
                    navigate('/pin');
                }
            } else {
                navigate("/checkProfile");
            }
        } else if (!localStorage.getItem('m_token') && localStorage.getItem("pin")) {
            // toast.error('Сессия истекла, авторизируйтесь снова:', {
            //     position: "top-center",
            //     autoClose: 3000
            // });
            return;
        } else if (localStorage.getItem("pin")) {
            if (localStorage.getItem('isPin')) {
                if (localStorage.getItem('isPin') === "false") {
                    navigate("/checkProfile");
                } else {
                    navigate('/pin');
                }
            } else {
                navigate("/checkProfile");
            }
        } else if (localStorage.getItem("m_token")) {
            if (localStorage.getItem('isPin')) {
                if (localStorage.getItem('isPin') === "false") {
                    navigate("/checkProfile");
                } else {
                    navigate('/pin');
                }
            } else {
                navigate("/checkProfile");
            }
        } else {
            // clear local storage (удаляем из localStorage всю информацию за исключением телефона и других)
            for (let i = 0, len = localStorage.length; i < len; ++i) {
                if (localStorage.key(i) === 'phone') {
                    continue;
                }
                if (localStorage.key(i) === 'vkloginprocess') {
                    continue;
                }
                if (localStorage.key(i) === 'pin') {
                    continue;
                }
                if (localStorage.key(i) === 'language') {
                    continue;
                }
                if (localStorage.key(i) === 'isPin') {
                    continue;
                }
                if (localStorage.key(i) === 'last_start_param') {
                    continue;
                }
                localStorage.removeItem(localStorage.key(i));
            }
            navigate('/start');
        }
    }, [navigate, isOnline]);

    const getAuth = async (token) => {
        try {
            const response = await fetch(`${config.app.host}/api/v1/integration/getUserToken`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: token, // <-- если это просто строка, ок; если JSON-объект, нужно JSON.stringify()
            });

            if (!response.ok) {
                const errorText = await response.text(); // читаем тело ошибки как строку
                console.log("Error: " + errorText);
                return;
            }

            const responseObject = await response.json();  // здесь нужно await
            localStorage.setItem('m_token', responseObject.token);
            localStorage.setItem('phone', responseObject.phone);
            localStorage.setItem('groupId', responseObject.phone);

            navigate('/checkProfile');
        } catch (error) {
            // toast.error('Ошибка: ' + error.message, {
            //     position: "top-center",
            //     autoClose: 3000,
            //     style: { color: "white", backgroundColor: "black" },
            // });
            return;
        }
    };

    const handleWebToken = async (token) => {
        if (localStorage.getItem("token_processed")) {
            return;
        }

        setLoading(true);

        try {
            const response = await fetch(`${config.app.host}/api/v1/integration/exchangeToken`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ token })
            });

            setLoading(false);

            if (!response.ok) {
                return;
            }

            const responseObject = await response.json();

            localStorage.setItem('m_token', responseObject.token);
            localStorage.setItem('phone', responseObject.phone);
            localStorage.setItem('groupId', responseObject.phone);

            localStorage.setItem("token_processed", "true"); // 👈 защитный флаг
            window.location.hash = "";
            if (window.location.pathname !== "/checkProfile") {
                navigate("/checkProfile");
            }
        } catch (err) {
            console.error("Ошибка при запросе:", err);
            setLoading(false);
        }
    };

    const handleBegin = () => {
        navigate('/step2');
    }

    if (isOnline === null) {
        return (
            <div className={styles.container}>
                <p>Проверка соединения...</p>
            </div>
        );
    }

    // Если бэкенд недоступен, не рендерим основной контент
    if (!isOnline) {
        return null; // Редирект уже произошел в useEffect
    }

    return (
        <div className={styles.container}>
            {
                loading ? (
                    <div className={styles.containerInline}>
                        <Loading />
                    </div>
                ) : (
                    <div className={styles.container}>
                        <TelegramHeader />
                        <div className={styles.imageWrapper}></div>
                        <div className={styles.content}>
                            <h1 className={styles.title}>ПСС</h1>
                            <p className={styles.description}>
                                {/* Откройте для себя простой и быстрый доступ к зарядным станциям по всему миру */}
                                {localStorage.getItem('language') === 'ru' ? localeRu.description : localeEn.description}
                            </p>
                            <button className={styles.startButton} onClick={handleBegin}>
                                <p className={styles.textButton}>{localStorage.getItem('language') === 'ru' ? localeRu.start_button : localeEn.start_button}</p>
                                <span className={styles.arrow}>➔</span>
                            </button>
                        </div>

                    </div>
                )
            }
        </div>
    );
};

export default NStartScreen;